import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.organizationStructure],
        config: {
            field: "Código de gerencia",
            headerName: getLocalizedString("managementCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.organizationStructure],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.organizationStructure],
        config: {
            field: "Código de departamento",
            headerName: getLocalizedString("departmentCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.organizationStructure],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.organizationStructure],
        config: {
            field: "Código de sección",
            headerName: getLocalizedString("sectionCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.organizationStructure],
        config: {
            headerName: getLocalizedString("section"),
            field: "Sección",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.organizationStructure],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "Centro de costo de gestión",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.organizationStructure],
        config: {
            headerName: getLocalizedString("businessUnit"),
            field: "Unidad de negocio",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["organizationOccupation"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["organizationOccupation"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["organizationOccupation"],
        config: {
            headerName: getLocalizedString("plantPersonnel"),
            field: "Personal de planta",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["organizationOccupation"],
        config: {
            headerName: getLocalizedString("positionEditorAssistant"),
            field: "Asistente",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["organizationOccupation"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["organizationOccupation"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["organizationOccupation"],
        config: {
            headerName: getLocalizedString("section"),
            field: "Seccion",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["organizationOccupation"],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "Centro de costo de gestión",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["organizationOccupation"],
        config: {
            headerName: getLocalizedString("businessUnit"),
            field: "Unidad de negocio",
            filter: "agSetColumnFilter",
        }
    },
]